export default __webpack_public_path__ + "static/media/vCake.813fe44e.svg";